export type ToastTone = 'info' | 'error'
export type ToastHandler = (message: string, tone?: ToastTone) => void

let handler: ToastHandler | null = null

export function setToastHandler(next: ToastHandler | null) {
  handler = next
}

export function toast(message: string, tone: ToastTone = 'info') {
  handler?.(message, tone)
}
